__webpack_require__.p = "/fuglar/";